// In-memory cache for calculations data
export const calculationsCache = {
  data: null,
  loadedAt: null,
  isLoaded: false,
  ttl: 30 * 60 * 1000, // 30 minutes in milliseconds

  get isExpired() {
    if (!this.loadedAt) return true;
    return Date.now() - this.loadedAt > this.ttl;
  },

  set(data) {
    this.data = data;
    this.loadedAt = Date.now();
    this.isLoaded = true;
  },

  clear() {
    this.data = null;
    this.loadedAt = null;
    this.isLoaded = false;
  },

  updateProduct(productKey, updatedProduct) {
    if (this.data?.products && this.data.products[productKey]) {
      this.data.products[productKey] = updatedProduct;
      this.loadedAt = Date.now(); // Update timestamp to reflect the change
    }
  }
};

// Check if this is a hard reload (not SPA navigation)
export const isHardReload = () => {
  try {
    const navigation = performance.getEntriesByType("navigation")[0];
    return navigation?.type === "reload" || navigation?.type === "navigate";
  } catch (e) {
    // Fallback: if performance API is not available, assume reload
    return true;
  }
};